"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawModalSchema = void 0;
const yup = __importStar(require("yup"));
const WithdrawModalSchema = (balance, payId) => yup.object().shape({
    amount: yup
        .number()
        .typeError("Please enter an amount")
        .required("Please enter an amount")
        .positive("Amount must be greater than 0")
        .max(balance / 100, "Amount must be less than or equal to your balance"),
    reference: yup
        .string()
        .typeError("Please enter a reference")
        .required("Please enter a reference")
        .max(payId ? 280 : 18, "Reference must be less than or equal to 18 characters")
        // eslint-disable-next-line no-useless-escape
        .matches(payId ? /^[\s\S]*$/ : /^[a-zA-Z0-9 \.\(\+\$\*\)\^\[\];\-\/,%_?:#@’=&!]*$/, {
        excludeEmptyString: true,
        message: "Reference contains invalid characters",
    }),
});
exports.WithdrawModalSchema = WithdrawModalSchema;
//# sourceMappingURL=WithdrawModalSchema.js.map